import React from "react";
import "./Card.css";
import "@fontsource/roboto";
import "@fontsource/roboto/700.css";
import PersonIcon from "@mui/icons-material/Person";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import HotelIcon from "@mui/icons-material/Hotel";
import PeopleIcon from "@mui/icons-material/People";
import InfoIcon from "@mui/icons-material/Info";

const Card = ({ moreInfo, onResponse }) => {
  const firstName = moreInfo.customer_Fname || onResponse?.data?.message?.Customer_Fname || "";
  const lastName = moreInfo.customer_Lname || onResponse?.data?.message?.Customer_Lname || "";
  const checkIn = moreInfo?.arriving_DateTime?.split("T")[0] || onResponse?.data?.message?.Arriving_DateTime?.split("T")[0] || "";
  const checkOut = moreInfo?.depature_DateTime?.split("T")[0] || onResponse?.data?.message?.Depature_DateTime?.split("T")[0] || "";
  const adults = moreInfo?.num_Of_Adults || onResponse?.data?.message?.Num_Of_Adults || 0;
  const kids = moreInfo?.num_Of_Kids || onResponse?.data?.message?.Num_Of_Kids || 0;
  const checkStatus = moreInfo?.status || onResponse?.data?.message?.Status || "Pending";

  return (
    <div className="card" style={{ fontFamily: "Roboto" }}>
      <span className="card-header">Reservation Summary</span>

      <div className="card-grid">
        <div className="detail-item">
          <PersonIcon className="detail-icon" />
          <div className="detail-content">
            <span className="detail-label">Primary Guest</span>
            <span className="detail-value">{`${firstName} ${lastName}`}</span>
          </div>
        </div>

        <div className="detail-item">
          <PeopleIcon className="detail-icon" />
          <div className="detail-content">
            <span className="detail-label">Accompanying Guests</span>
            <span className="detail-value">{`${adults} Adults, ${kids} Kids`}</span>
          </div>
        </div>

        <div className="detail-item">
          <CalendarTodayIcon className="detail-icon" />
          <div className="detail-content">
            <span className="detail-label">Check-In Date</span>
            <span className="detail-value">{checkIn}</span>
          </div>
        </div>

        <div className="detail-item">
          <CalendarTodayIcon className="detail-icon" />
          <div className="detail-content">
            <span className="detail-label">Check-Out Date</span>
            <span className="detail-value">{checkOut}</span>
          </div>
        </div>

        <div className="detail-item">
          <HotelIcon className="detail-icon" />
          <div className="detail-content">
            <span className="detail-label">Room Type</span>
            <span className="detail-value">Entire Villa</span>
          </div>
        </div>

        <div className="detail-item">
          <InfoIcon className="detail-icon" />
          <div className="detail-content">
            <span className="detail-label">Check-In Status</span>
            <span className={`detail-value status-pill ${checkStatus.toLowerCase()}`}>
              {checkStatus}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card;

